export default {
  warnings: {
    canNotAccessMicrophone: "We can't access your microphone. Please check if you have microphone access enabled and try again.",
    webspeechNotSupported: "Speech dictation (Web Speech API) is not enabled in this browser.",
    speechToTextFailed: "Speech transcription failed. Please try again.",
    reEnableMicrophone: "Please enable your microphone in browser.",
    notSupportedOnThisBrowser: "This feature is not supported on this browser.",
    notAllowed: "You are not allowed to access this page.",
    noGroupsAssigned: "You are not assigned to any group. Please contact your organization admin.",
    organizationHasNoContent: "Organization/Group has no content. Please contact your organization admin.",
    sessionExpired: "Your session has expired. Please log in again.",
    speechAi: "The voice that you will hear is an AI generated voice.",
  },
  dictation: {
    durationLabel: "{elapsed} of {limit}",
    stopped: "Dictation was interrupted.",
    stoppedMaxDuration: "Dictation was automatically stopped after reaching the {limit} limit.",
    stoppedSilence: "Dictation was automatically stopped after {seconds} seconds of silence.",
  },
  buttons: {
    back: "Back",
    analyze: "Analyze",
    showAnalysis: "Show My Analysis",
    support: "Support",
    close: "Close",
    save: "Save",
    create: "Create",
    saving: "Saving...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    view: "View",
  },
  termsLink: "https://www.provocator.ai/en/terms-of-use",
  gameStatuses: {
    completed: "Completed",
    in_progress: "Started",
    not_started: "Not Started",
  },
  gameTypes: {
    gymShort: "Short Gym",
    challange: "Model Situation",
    gymLong: "Long Gym",
  },
  others: {
    selected: "selected",
  },
};
